// Max number of top-level "lines" (blocks; a view block counts as one) each
// preview surface renders before it is cut and an ellipsis is shown. `undefined`
// means no limit. Every preview reads its limit from this object, so you can
// change all of the limits in one place.
export const PREVIEW_LINES = {
  // Top-bar search-result dropdown.
  search: 2,
  // "New from template" modal tiles.
  template: 2,
  // Link / backlink hover popover.
  hover: 3,
  // Card-link autocomplete suggestion dropdown.
  suggest: 2,
  // Card previews inside embedded view blocks.
  kanban: 3,
  network: 3,
  // The preview lengths of list-view items: short, medium (2×), and long (3×),
  // plus full, which has no limit.
  previewShort: 3,
  previewMedium: 6,
  previewLong: 9,
  previewFull: undefined as number | undefined,
} as const;

// The preview lengths of list-view items. The CSS class `.preview-len--<length>`
// (see style.css) sets the max-height of the box, and the line limit below
// limits the content blocks. Keep the two in sync.
export type PreviewLength = "short" | "medium" | "long" | "full";

export const PREVIEW_LENGTH_LINES: Record<PreviewLength, number | undefined> = {
  short: PREVIEW_LINES.previewShort,
  medium: PREVIEW_LINES.previewMedium,
  long: PREVIEW_LINES.previewLong,
  full: PREVIEW_LINES.previewFull,
};

// Map a stored mode string ("preview-short" | … | "full", plus legacy "preview"
// / "single-line") to a length. Unknown values fall back to "short".
export function previewLength(mode: string | undefined): PreviewLength {
  switch (mode) {
    case "full":
      return "full";
    case "preview-medium":
      return "medium";
    case "preview-long":
      return "long";
    default:
      return "short";
  }
}
